import { Card } from '@/shared/ui/card'
import { Skeleton } from '@/shared/ui/skeleton'

// Loading placeholder mirroring MatchCard's shape (skeleton, not spinner).
//
// The chip rows were `h-7`, which the tokens' spacing remap resolves to 48px
// while the real `Chip` is `h-8` = 32px — so every card grew 16px per chip row
// the moment data landed, and a feed of them jumped. A skeleton that doesn't
// match the real element's height is worse than no skeleton: it promises a
// layout it won't keep. Heights here are explicit px for that reason; see the
// remap note in bottom-tab-bar.tsx.
export function MatchCardSkeleton() {
  return (
    <Card>
      <div className="p-4 flex flex-col gap-3">
        <div className="flex items-start justify-between gap-3">
          <div className="flex flex-col gap-2 flex-1">
            <Skeleton className="h-4 w-28" />
            <Skeleton className="h-3 w-16" />
          </div>
          <div className="flex flex-col gap-2 items-end">
            <Skeleton className="h-4 w-12" />
            <Skeleton className="h-3 w-10" />
          </div>
        </div>
        <div className="flex gap-2">
          <Skeleton className="h-[32px] w-12 rounded-full" />
          <Skeleton className="h-[32px] w-16 rounded-full" />
          <Skeleton className="h-[32px] w-20 rounded-full" />
        </div>
        <div className="flex items-center justify-between">
          <Skeleton className="h-[32px] w-20" />
          <Skeleton className="h-4 w-16" />
        </div>
      </div>
    </Card>
  )
}
